export default __webpack_public_path__ + "1598cd4d1fe5bba6e2bc9e8254e00978.png";